export default "__VITE_ASSET__D59Tfxjd__"